/* global Plotly */
// Plot.js
import React from 'react';
import PropTypes from 'prop-types';

class Line extends React.Component {

  constructor(props)  {

    super(props);

    this.state = {
      trace1: {time: [], y: [], name: "Price", mode: "lines", type: 'scatter', line: {color: 'rgb(76,175,80)'}},
      trace2: {time: [], y: [], name: "Ask", mode: "lines", type: 'scatter', line: {color: 'rgb(158, 25, 25)'}},
      trace3: {time: [], y: [], name: "Bid", mode: "lines", type: 'scatter', line: {color: 'rgb(10, 62, 154)'}},
      trace4: {time: [], y: [], name: "VWAP", mode: "lines", type: 'scatter', line: {color: 'rgb(2, 2, 2)'}},
    };
    this.draw = function (nextState) {
          //generate an "x" based on getTime
          var daycount = 0;
          if (nextState.trace1.time.length < 1) {
              Plotly.newPlot('line', [], {}, {displayModeBar: false});
              return;
          }
          //We require a 9:30 timeseries event to start every day
          var currentDate = new Date(nextState.trace1.time[0]).toJSON().substr(0, 10);
          var currentDayMs = new Date(nextState.trace1.time[0]).getTime();
          var tickvals = [0];
          var ticktext = [currentDate.substr(5, 5)];
          var handleNewDay = function (stamp) {
              var stampDate = new Date(stamp).toJSON().substr(0, 10);
              if (stampDate !== currentDate) {
                  currentDate = stampDate;
                  currentDayMs = new Date(stamp).getTime();
                  daycount++;
                  tickvals.push(23400000 * daycount);
                  ticktext.push(currentDate.substr(5, 5));
              }
          };
          var xvals = nextState.trace1.time.map((stamp, i) => {
              handleNewDay(stamp);
              //currentDayMs is the epoch at 9:30 the day of this stamp;
              //we want the x value to be the number of business ms simulated so far
              //daycount is the number of completed business days so far
              var thisEpoch = new Date(stamp).getTime();
              var msPerDay = 23400000;
              var x = thisEpoch - currentDayMs + msPerDay * daycount;
              tickvals.push(x);
              ticktext.push('');
              return x;
          });
          nextState.trace1.x = xvals;
          nextState.trace2.x = xvals;
          nextState.trace3.x = xvals;
          nextState.trace4.x = xvals;
          var findAnamolies = function(obj){
            var lowerCutoff = 10;
            var upperCutoff = 30;
            var badOnes=[];
            for (var i =0; i < obj.y.length; i++){
              if (obj.y[i] < lowerCutoff || obj.y[i] > upperCutoff){
                badOnes.push(i);
              }
            }
            badOnes.sort(function(a,b){ return b - a; });
            console.log(badOnes);
            for(var j = 0; j < badOnes.length; j++){
              obj.y.splice(badOnes[j], 1);
              obj.x.splice(badOnes[j], 1);
              obj.time.splice(badOnes[j], 1);
            }
            return obj;
          };


          var data = [nextState.trace1, findAnamolies(nextState.trace2), findAnamolies(nextState.trace3),  findAnamolies(nextState.trace4)];     // nextState.trace4];
          var getRange = function (xvals) {
              return [xvals.reduce((a, b) => parseFloat(a) <= parseFloat(b) ? a : b),
                      xvals.reduce((a, b) => parseFloat(a) >= parseFloat(b) ? a : b)];
          };
          var getYRange = function (yvals) {
              return [yvals.reduce((a, b) => parseFloat(a) <= parseFloat(b) ? a : b),
                      yvals.reduce((a, b) => parseFloat(a) >= parseFloat(b) ? a : b)];
          };
          // var yvals = nextState.trace1.y = () => {
          //   var y = saveSessionData.lastPrice;
          //   return y;
          // };//right here is where you left off
          // var yvals2 = nextState.trace2.y = () => {
          //   var y = saveSessionData.bid;
          //   return y;
          // };
          // var yvals3 = nextState.trace3.y = () => {
          //   var y = saveSessionData.ask;
          //   return y;
          // };
          // var yvals4 = nextState.trace4.y = () => {
          //   var y = saveSessionData.VWAP;
          //   return y;
          // };
          // nextState.trace1.y = yvals
          // nextState.trace2.y = yvals2
          // nextState.trace3.y =
          let wdth = document.querySelector('.graph-div').clientWidth;
          let hght = document.querySelector('.graph-div').clientHeight;
          var layout = {
              title: "",
              autosize: false,
              height: hght-34-15,
              width: wdth-30,
              dragmode: 'pan',
              margin: {
                  r: 1,
                  t: 5,
                  b: 50,
                  l: 34
              },
              showlegend: false,
              xaxis: {
                  autorange: true,
                  showticklabels:true,
                  domain: [0, 1],
                  range: [0, 100],
                  rangeslider: {range: getRange(xvals), visible: false},
                  title: '',
                  type: 'linear',
                  showgrid: false,
                  tickmode: "array",
                  tickfont: {size:14},
                  tickvals: tickvals,
                  ticktext: ticktext
              },
              yaxis: {
                  autorange: true,
                  domain: [0, 1],
                  range: getYRange(nextState.trace1.y),
                  type: 'linear'

              }
          };
          Plotly.newPlot('line', data, layout, {displayModeBar: false});
      }

  }

  componentDidMount() {
      window.addEventListener("resize",()=>{
        this.setState({rando: Math.random()});
        console.log("resize");
      });
      //console.log("Line componentDidMount");
      this.handlePoints = function (points) {

          this.setState({
                  trace1:
                      {
                          time: this.state.trace1.time.concat(points.map(el => el.time)),
                          y: this.state.trace1.y.concat(points.map(el => el.price)),
                          name: "Price", mode: "lines", type: 'scatter', line: {color: 'rgb(76,175,80)'}
                      },
                  trace2:
                    {
                          time: this.state.trace1.time.concat(points.map(el => el.time)),
                          y: this.state.trace2.y.concat(points.map(el => el.ask)),
                          name: "Ask", mode: "lines", type: 'scatter', line: {color: 'rgb(158, 25, 25)'}
                    },
                  trace3:
                    {
                          time: this.state.trace1.time.concat(points.map(el => el.time)),
                          y: this.state.trace3.y.concat(points.map(el => el.bid)),
                          name: "Bid", mode: "lines", type: 'scatter', line: {color: 'rgb(10, 62, 154)'}
                    },
                  trace4:
                    {
                          time: this.state.trace1.time.concat(points.map(el => el.time)),
                          y: this.state.trace3.y.concat(points.map(el => el.bid)),    //+1),      // test whether ANYTHING will appear at all.


                          //y: this.state.trace4.y.concat(points.map(el => el.VWAP)),     // <== THIS is the real line we want in there. -Nathan Bendich; May 19, 2022     


                          //y: 25.1,    // just a basic value to see whether / how we can get something on the graph
                          // y: this.state.trace3.y.concat(points.map(el => el.bid)),    //+1),      // test whether ANYTHING will appear at all.


                          name: "VWAP", mode: "lines", type: 'scatter', line: {color: 'rgb(2, 2, 2)'} // black
                    },
              }
          );

      };
      var timeseries = this.props.timeseries;

      this.handlePoints(timeseries);

  }

  componentWillReceiveProps(nextProps) {
      console.log("Line componentWillReceiveProps " + nextProps);
      //console.log(nextProps);
      var count = this.state.trace1.time.length;
      var propLength = nextProps.timeseries.length;
      //console.log(count, propLength);
      this.handlePoints(nextProps.timeseries.slice(count, propLength));  //  NOTE:    Line.js from Plotly in here    - Nathan Bendich,  May 20, 2022
  }

  componentWillUpdate(nextProps, nextState) {
      console.log("Line componentWillUpdate " + nextProps + " " + nextState);
      this.draw(nextState);
  }


  render() {
      //console.log("Line render");
      return (
          <div>
              <div id="line"></div>
          </div>
      );
  };
}

Line.propTypes = {
    timeseries: PropTypes.array
};

export default Line;



// WEBPACK FOOTER //
// ./src/components/Charts/Line.js